import { userClaimIds } from '../../utils/userClaims'
import { isValidPatientState, isValidPractitionerState, isValidStudentState } from './utils'

export const persistence = {
  practitionerApiUrl: '/api/onboarding/practitioner',
  patientApiUrl: '/api/onboarding/patient',
  studentApiUrl: '/api/onboarding/student',
} as const

type OnboardingClaim = {
  claimId: (typeof userClaimIds)['onboardPatient' | 'onboardPractitioner' | 'onboardStudent']
  validateState: (state: string) => boolean
}

export const onboardingClaims: OnboardingClaim[] = [
  {
    claimId: userClaimIds.onboardPatient,
    validateState: isValidPatientState,
  },
  {
    claimId: userClaimIds.onboardPractitioner,
    validateState: isValidPractitionerState,
  },
  {
    claimId: userClaimIds.onboardStudent,
    validateState: isValidStudentState,
  },
] as const
